import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NoPage from './view/NoPage';
import routes from './routes/routes';
import NavigationBar from './components/AppBar';
import "./components/Components.css";
import "./view/components/style.css";
import Footer from './components/Footer';
import { useState, useEffect } from 'react';
import Loader from './components/Loader'; // Create a Loader component
import { ModalProvider } from './context/ModalContext';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulating page load completion
    setLoading(false);
  }, []);

  return (
    <>
      {loading && <Loader />}
      {!loading && (
        <Router>
          <ModalProvider>
          <NavigationBar />
          <Routes>
            {routes.map(({ path, component: Component }, index) => (
              <Route key={index} path={path} element={<Component />} />
            ))}
            <Route path="*" element={<NoPage />} />
          </Routes>
          <Footer />
          </ModalProvider>
        </Router>
      )}
    </>
  );
}

export default App;
